import { defineStore } from 'pinia';
import CityService from '@/service/CityService';

export const useCityStore = defineStore('useCityStore', {
  state: () => ({
    city: [],
    returning: []
  }),
  getters: {
    getUrlUploadFile: () => {
      const Service = new CityService();
      return Service.getUrlPreview();
    }
  },
  actions: {
    async getListManagement() {
      const cityService = new CityService();
      const res = await cityService.getListManagement();
      return res?.data;
    },

    async getCityGateways() {
      const cityService = new CityService();
      const res = await cityService.getCityGateways();
      return res?.data;
    },

    async getCityDestinations() {
      const cityService = new CityService();
      const res = await cityService.getCityDestinations();
      return res?.data;
    },

    async addCity(payload: any) {
      const cityService = new CityService();
      const res = await cityService.addCity(payload);
      return res?.data;
    },

    async updateCity(payload: any) {
      const cityService = new CityService();
      const res = await cityService.updateCity(payload);
      return res?.data;
    },

    async deleteCity(payload: any) {
      const cityService = new CityService();
      const res = await cityService.deleteCity(payload);
      return res?.data;
    },

    async importCity(payload: any) {
      const cityService = new CityService();
      const res = await cityService.importCity(payload);
      return res?.data;
    },

    async getVersionRevertCity(type: string) {
      const cityService = new CityService();
      const res = await cityService.getVersionRevertCity(type);
      return res?.data;
    },

    async getPreviewFileCity(fileName: string) {
      const cityService = new CityService();
      const res = await cityService.getPreviewFileCity(fileName);
      return res?.data;
    },

    async revertFileCity(fileName: string) {
      const cityService = new CityService();
      const res = await cityService.revertFileCity(fileName);
      return res?.data;
    },

    async getDestAir() {
      const cityService = new CityService();
      const res = await cityService.getDestAir();
      this.returning = res?.data;
      return res?.data;
    },

    async checkJawBrochure(jawType: string, payload: any) {
      const cityService = new CityService();
      const res = await cityService.checkJawBrochure(jawType, payload);
      return res?.data;
    },

    getAirportCityDetail(code: string) {
      return this.returning?.find((airport) => airport.airportCode === code);
    }
  }
});
